var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDocumentOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 10C13 10.5523 12.5523 11 12 11H8C7.44771 11 7 10.5523 7 10C7 9.44772 7.44771 9 8 9H12C12.5523 9 13 9.44772 13 10Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 13C11 13.5523 10.5523 14 10 14H8C7.44771 14 7 13.5523 7 13C7 12.4477 7.44771 12 8 12H10C10.5523 12 11 12.4477 11 13Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 18C4.34315 18 3 16.6569 3 15V5C3 3.34315 4.34315 2 6 2H11.1167C11.9607 2 12.7656 2.35547 13.3341 2.97923L16.2173 6.14291C16.7209 6.69545 17 7.4161 17 8.16368V15C17 16.6569 15.6569 18 14 18H6ZM5 15C5 15.5523 5.44772 16 6 16H14C14.5523 16 15 15.5523 15 15V8.16368C15 8.10851 14.9954 8.05378 14.9865 8H8C7.44771 8 7 7.55228 7 7C7 6.44772 7.44771 6 8 6H11V4H6C5.44772 4 5 4.44771 5 5V15Z",
  fill: "currentColor"
})));
export { SvgDocumentOutline20 as ReactComponent };